export default __webpack_public_path__ + "static/media/sshippingicon.a879e36d.svg";